package com.essntl.features.category.ui.allcategories.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.uikit.components.image.AsyncUrlIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun CategoryItem(
    category: CategoryModel,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier
            .height(40.dp)
            .border(
                width = 1.dp,
                color = with(MaterialTheme.esColorScheme) {
                    borderPrimary
                },
                shape = CircleShape,
            )
            .clip(CircleShape)
            .background(
                with(MaterialTheme.esColorScheme) {
                    bgSecondary
                },
            )
            .padding(horizontal = 2.spacing),
    ) {
        if (!category.iconUrl.isNullOrBlank()) {
            AsyncUrlIcon(
                url = category.iconUrl ?: "",
                contentDescription = category.name,
                tint = Color(0xFF8985A2),
                modifier = Modifier.size(24.dp),
            )

            Spacer(modifier = Modifier.width(.5f.spacing))
        }

        Text(
            text = category.name,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p1Regular16,
        )
    }
}